import axios from "axios";
// import router from "@/router";
import store from "@/store";

export default {
  request(method, uri, data = null, headers = {}, responseType = "json") {
    if (!method) {
      window.console.error("API function call requires method argument");
      return;
    }

    if (!uri) {
      window.console.error("API function call requires uri argument");
      return;
    }

    if (uri !== "/authentication") {
      // if (new Date() > new Date(store.state.expiration)) {
      //   this.renewToken();
      // } else {
      headers = Object.assign(headers, {
        Authorization: "Bearer " + store.getters.token
      });
      // }
    }

    var request = {
      baseUrl: `/`,
      method,
      url: `/api` + uri,
      data,
      headers: headers,
      responseType: responseType
    };

    return axios(request);
  }
  // renewToken() {
  //   axios({
  //     method: "post",
  //     url: config.serverURI + "/login",
  //     data: {
  //       username: store.state.username,
  //       secret: store.state.refreshToken,
  //       type: "RefreshToken"
  //     }
  //   })
  //     .then(response => {
  //       /* Setting user in the state and caching record to the localStorage */
  //       if (response.data.authenticated) {
  //         store.commit("login", response.data);
  //       } else {
  //         store.commit("logout");
  //         router.replace("/login");
  //       }
  //     })
  //     .catch(() => {
  //       store.commit("logout");
  //       router.replace("/login");
  //     });
  // }
};
